<template>
  <div class="relative z-10 flex-shrink-0 flex h-16 bg-white shadow border-b-4 border-blue-500">
    <button @click="$emit('toggleSidebar')" aria-label="Open sidebar" class="px-4 text-gray-500 focus:outline-none focus:bg-gray-100 focus:text-gray-600 md:hidden">
      <svg-vue class="h-6 w-6" icon="font-awesome.bars-regular"></svg-vue>
    </button>
    <div class="w-full px-12 flex justify-end">
      <div class="flex">
        <div class="ml-4 flex-1 flex items-center md:ml-8">
          <div class="ml-3 relative" v-on-clickaway="closeDropdown">
            <button
              @click="dropdownOpen = !dropdownOpen"
              aria-haspopup="true"
              aria-label="User menu"
              class="max-w-xs flex items-center text-sm rounded-full focus:outline-none focus:shadow-outline"
              id="user-menu"
            >
              <img :src="$store.state.user.avatar === 'gravatar' ? $store.state.user.gravatar : $store.state.user.avatar" alt="User avatar" class="h-8 w-8 rounded-full" />
            </button>
            <transition
              duration="100"
              enter-active-class="transition ease-out duration-100"
              enter-class="transform opacity-0 scale-95"
              enter-to-class="transform opacity-100 scale-100"
              leave-active-class="transition ease-in duration-75"
              leave-class="transform opacity-100 scale-100"
              leave-to-class="transform opacity-0 scale-95"
            >
              <div class="origin-top-right z-10 absolute right-0 mt-2 w-56 rounded-md shadow-lg" v-show="dropdownOpen">
                <div aria-labelledby="user-menu" aria-orientation="vertical" class="py-1 rounded-md bg-white shadow-xs" role="menu">
                  <div class="px-4 text-xs truncate text-right text-gray-500"> {{ $store.state.settings.version }} v </div>
                  <div class="flex items-center px-4 ce py-2 border-b border-gray-100">
                    <img :src="$store.state.user.avatar === 'gravatar' ? $store.state.user.gravatar : $store.state.user.avatar" alt="User avatar" class="h-8 w-8 mr-3 align-middle rounded-full" />
                    <div class="w-40">
                      <div class="text-sm font-medium truncate text-gray-800">
                        {{ $store.state.user.name }}
                      </div>
                      <div class="text-xs truncate text-gray-500">
                        {{ $store.state.user.email }}
                      </div>
                    </div>
                  </div>
                  <router-link
                    @click.native="dropdownOpen = false"
                    class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition ease-in-out duration-150"
                    role="menuitem"
                    to="/workshop"
                    >{{ $t('Workshop') }}</router-link
                  >
                  <router-link
                    @click.native="dropdownOpen = false"
                    class=" block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition ease-in-out duration-150"
                    role="menuitem"
                    to="/account"
                    >{{ $t('Account settings') }}</router-link
                  >
                  <a
                    class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition ease-in-out duration-150"
                    href="https://codecanyon.net/user/rose-finch"
                    rel="noopener"
                    role="menuitem"
                    target="_blank"
                    >{{ $t('Help OR Report issue') }}</a
                  >
                  <a
                    class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition ease-in-out duration-150"
                    href="https://google.com/repair-box"
                    rel="noopener"
                    role="menuitem"
                    target="_blank"
                    >{{ $t('Documentation') }}</a
                  >
                   <a
                    class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition ease-in-out duration-150"
                    href="https://google.com/repair-box/get-started/change-log"
                    rel="noopener"
                    role="menuitem"
                    target="_blank"
                    >{{ $t('Version change log') }}</a
                  >
                  <a @click.prevent="signOut" class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition ease-in-out duration-150" href="/auth/logout" rel="noopener" role="menuitem">{{
                    $t('Sign out')
                  }}</a>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mixin as clickaway } from 'vue-clickaway';

export default {
  name: 'navbar',
  mixins: [clickaway],
  data() {
    return {
      dropdownOpen: false,
    };
  },
  methods: {
    signOut() {
      this.dropdownOpen = false;
      this.$store.commit('logout');
      this.$router.push('/auth/login');
    },
    closeDropdown() {
      this.dropdownOpen = false;
    },
  },
};
</script>
